import { Box } from '@mui/material';
import { AgColor } from '../Styles/AgColor';
import AgLoading from '../AgLoading';
import AgTypography from '../Styles/AgTypography';
import { CSSProperties } from '@mui/styles';
import AgLogos from '../AgLogos';

const AgLoadingCard = (
  { text, CircularLoading, style, cardOnly, showLogo }:
  {text?: string; CircularLoading?: boolean; style?: CSSProperties; cardOnly?: boolean; showLogo?: boolean}
) => {
  return (cardOnly ?
    <Box 
      sx={{
        width: '480px', 
        height: '152px', 
        borderRadius: '6px',
        border: `1px solid ${AgColor.grey3}`,
        backgroundColor: AgColor.grey0, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        flexDirection: 'column',
        boxShadow: '0px 1px 2px 0px #0000000D' }}>
      <AgLoading CircularLoading = { CircularLoading }/>
      <AgTypography contentStyle={'AP.H4.Bold'} sx={{ color: AgColor.primaryDark }}>{text}</AgTypography> 
    </Box> :
    <Box style={style} 
      sx={{
        backgroundColor: AgColor.grey1, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        left: '0px',
        top: '0px',
        bottom: '0px',
        right: '0px',
        zIndex: 1000,
        position: 'absolute',
      }}>
      {showLogo && 
      <Box sx={{ 
        position: 'absolute',
        top: '40px',
        left: '50%',
        transform: 'translateX(-50%)'
      }}>
        <AgLogos type={'horizantal'} background='light' />
      </Box>}
      <Box
        sx={{
          width: '480px', 
          height: '152px', 
          borderRadius: '6px',
          border: `1px solid ${AgColor.grey3}`,
          backgroundColor: AgColor.grey0, 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          flexDirection: 'column',
          boxShadow: '0px 1px 2px 0px #0000000D' }}>
        <AgLoading CircularLoading = { CircularLoading }/>
        <AgTypography contentStyle={'AP.H4.Bold'} sx={{ color: AgColor.primaryDark }}>{text}</AgTypography> 
      </Box>
    </Box>
  );
};

export default AgLoadingCard;
